/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, ReactNode, useCallback, useEffect, useMemo, useState, useRef } from "react";
import ChatController from "../controllers/ChatController";
import { ChatRoom } from "../models/ChatRoom";
import { Message } from "../models/Message";
import RequestController from "../controllers/RequestController";
import NotificationController from "../controllers/NotificationController"
import Wrapper from "../utils/msrpWrapper";
import Global from "../globals/globals";
import { useWebsocketHook } from "../hooks/useWebsocketHook";
import generateRandomString from "../MSRP/utilities/generators";
import { mapJobRoleToMsrpRole, mapJobRoleToMsrpSubrole } from "../MSRP/utilities/msrpRole";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { toast } from "@/lib/toast";
import { createRequestControlMessage } from "../utils/cmsgBuilder";
import { setAvailableAgents } from "../../src/globals/availableAgents";
import { Agent } from "../../src/globals/availableAgents";
import { setHandleAgentListResponse } from "../controllers/agentListController";
import { MyNotifications } from "@/models/MyNotifications";
import { MyRequest } from "@/models/MyRequest";
import { FileMessage } from "../models/FileMessage";
import obtainSessionKey from "../MSRP/utilities/obtainSessionKey";
import { SeenEntry } from "../models/ChatMessage";
import { getWithExpiry, removeWithExpiry } from "@/utils/storage";
import { endSession } from "@/utils/session";
import { useUnreadDividerContext } from "@/context/UnreadDividerContext";
import { secureGet } from "@/utils/secureStorage";

export interface ChatContextInterface {
  rooms: ChatRoom[];
  setRooms: React.Dispatch<React.SetStateAction<ChatRoom[]>>;
  isAuthenticated: boolean;
  setIsAuthenticated: React.Dispatch<React.SetStateAction<boolean>>;
  loading: boolean;
  currentRoom: ChatRoom | null;
  handleAgentListResponse: (names: string[], statuses: string[], types: number[]) => void;
  handleChatListResponse: (names: string[], types: string[], statuses: string[]) => void;
  updateAgentList: (filter: string) => void;
  updateChatList: (type: string, personal: boolean, status: string) => void;
  addRoom: (chatroomName: string, participants: string[], chatroomId: string, status: string, type: string) => void;
  handleSelectRoom: (room?: ChatRoom | null) => void;
  handleReceiveFileMessage: (filemessage: FileMessage) => void;
  handleSendFileMessage: (filemessage: FileMessage) => void;
  handleReceiveMessage: (text: string, messageId: string, sender: string, receiver: string, isOwner: boolean, roomType: string) => void;
  handleSessionActivation: (chatroomName: string, status: boolean) => void;
  requestController: RequestController;
  notificationController: NotificationController;
  controller: ChatController;
  wrapper: Wrapper | null;
  setWrapper: React.Dispatch<React.SetStateAction<Wrapper | null>>;
  agents: Agent[];
  availableRooms: { name: string; type: string; status: string }[];
  setIsCreator: (chatroomId: string, iscreator: boolean) => void;
  setAvailableRooms: React.Dispatch<React.SetStateAction<{ name: string; type: string; status: string }[]>>;
  currentMode: string;
  setCurrentMode: React.Dispatch<React.SetStateAction<string>>
  currentLanguage: string;
  setcurrentLanguage: React.Dispatch<React.SetStateAction<string>>
  handlePublishEvent: (event: string) => void;
  addNotification: (notification: MyNotifications) => void;
  handleRemoveMessage: (messageId: string, chatRoomId: string) => void;
  handleupdateMessage: (msgId: string, newMessage: string) => void;
  notifCount: number;
  setnotifCount: React.Dispatch<React.SetStateAction<number>>
  reqCount: number;
  setreqCount: React.Dispatch<React.SetStateAction<number>>
  handleaddRequest: (newRequest: MyRequest) => void;
  handleremoveRequest: (reqId: string) => void;
  handlefindRequest: (reqId: string) => MyRequest | null;
  handleaddServerRequest: (newRequest: MyRequest) => void;
  handleremoveServerRequest: (reqId: string) => void;
  handlefindServerRequest: (reqId: string) => MyRequest | null;
  handleupdateReqStatusById: (reqId: string, status: string) => void;
  repliedMessage: Message | null;
  setRepliedMessage: React.Dispatch<React.SetStateAction<Message | null>>;
  handleAddMessageHistory: (messages: any[], pageNumber: number, totalPageNumber: number) => void;
  // handleAddMessageHistoryArray: (messages: any[], pageNumber: number, hasMore: boolean) => void;
  handleDeleteChatRoom: (roomId: string) => void;
  saveCurrentRoomToStorage: (room: ChatRoom | null) => void;
  handlemarkAsRead: (chatID: string) => void;
  messageHistoryReq: (toName: string, nextPage: number, limit: number) => void;
  clearAllChatRooms: () => void;
  handleClearChatRoomMessagesByName: (username: string) => boolean;
  handleLeaveFromChat: (chatID: string) => void;
  setAdmin: (chatroomId: string, admin: string) => void;
  handleAddParticipant: (roomId: string, participant: string) => void;
  handleRemoveParticipant: (roomId: string, participant: string) => void;
  updateMessageStatus: (messageId: string, status: string, Date: Date, name: string) => void;
  setCurrentRoom: React.Dispatch<React.SetStateAction<ChatRoom | null>>;
  restoreRoomFromUrl: (roomId: string) => ChatRoom | null;
  requestNotificationPermission: () => Promise<boolean>;

  // Connection state
  connectionState: string;
  isConnected: boolean;
  isReconnecting: boolean;

}

export const ChatContext = createContext<ChatContextInterface | null>(null);

export default function ChatContextProvider({ children }: { children: ReactNode }) {
  const [rooms, setRooms] = useState<ChatRoom[]>([]);
  const [currentRoom, setCurrentRoom] = useState<ChatRoom | null>(null);
  const [currentMode, setCurrentMode] = useState<string>("available");
  const [currentLanguage, setcurrentLanguage] = useState<string>("English");

  const [wrapperInstance, setWrapperInstance] = useState<Wrapper | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  // const [loading, setLoading] = useState(true);
  const { socketInstance, createSocketInstance, loading, setLoading } = useWebsocketHook();
  const controller = useMemo(() => new ChatController(), []);
  const notificationController = useMemo(() => new NotificationController(), []);
  const [isSocketOpen, setIsSocketOpen] = useState(false);
  const [agents, setAgents] = useState<Agent[]>([]);
  const [availableRooms, setAvailableRooms] = useState<{ name: string; type: string, status: string }[]>([]);
  const [notifCount, setnotifCount] = useState<number>(0);
  const [reqCount, setreqCount] = useState<number>(0);
  const [repliedMessage, setRepliedMessage] = useState<Message | null>(null);
  const notificationAudioContextRef = useRef<AudioContext | null>(null);

  // Connection state
  const [connectionState, setConnectionState] = useState<string>('disconnected');
  const isConnected = connectionState === 'authenticated';
  const isReconnecting = connectionState === 'reconnecting';

  // Unread divider context for tracking dividers across all rooms
  const unreadDividerContext = useUnreadDividerContext();

  // Track window focus state for unread divider
  const [isWindowFocused, setIsWindowFocused] = useState(!document.hidden);

  const playIncomingMessageSound = useCallback(async () => {
    if (typeof window === "undefined") return;

    const AudioContextCtor = window.AudioContext || (window as any).webkitAudioContext;
    if (!AudioContextCtor) return;

    const audioContext = notificationAudioContextRef.current || new AudioContextCtor();
    notificationAudioContextRef.current = audioContext;

    if (audioContext.state === "suspended") {
      try {
        await audioContext.resume();
      } catch {
        return;
      }
    }

    if (audioContext.state !== "running") return;

    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();

    oscillator.type = "sine";
    oscillator.frequency.value = 880;
    gainNode.gain.value = 0.0001;

    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);

    const now = audioContext.currentTime;
    gainNode.gain.setValueAtTime(0.0001, now);
    gainNode.gain.exponentialRampToValueAtTime(0.18, now + 0.01);
    gainNode.gain.exponentialRampToValueAtTime(0.0001, now + 0.2);

    oscillator.start(now);
    oscillator.stop(now + 0.22);
  }, []);

  const playClientConnectedPing = useCallback(async () => {
    if (typeof window === "undefined") return;

    const AudioContextCtor = window.AudioContext || (window as any).webkitAudioContext;
    if (!AudioContextCtor) return;

    const audioContext = notificationAudioContextRef.current || new AudioContextCtor();
    notificationAudioContextRef.current = audioContext;

    if (audioContext.state === "suspended") {
      try {
        await audioContext.resume();
      } catch {
        return;
      }
    }

    if (audioContext.state !== "running") return;

    const now = audioContext.currentTime;
    const chirpCount = 4;
    const chirpGap = 0.12;
    const chirpDuration = 0.18;

    for (let index = 0; index < chirpCount; index += 1) {
      const startTime = now + index * chirpGap;
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();

      oscillator.type = "sine";
      oscillator.frequency.value = 1040;
      gainNode.gain.value = 0.0001;

      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);

      gainNode.gain.setValueAtTime(0.0001, startTime);
      gainNode.gain.exponentialRampToValueAtTime(0.16, startTime + 0.015);
      gainNode.gain.exponentialRampToValueAtTime(0.0001, startTime + chirpDuration);

      oscillator.start(startTime);
      oscillator.stop(startTime + chirpDuration + 0.02);
      oscillator.onended = () => {
        oscillator.disconnect();
        gainNode.disconnect();
      };
    }
  }, []);

  useEffect(() => {
    return () => {
      if (notificationAudioContextRef.current && notificationAudioContextRef.current.state !== "closed") {
        notificationAudioContextRef.current.close().catch(() => {
        });
      }
      notificationAudioContextRef.current = null;
    };
  }, []);

  // Window focus tracking effect
  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsWindowFocused(!document.hidden);
    };

    const handleFocus = () => {
      setIsWindowFocused(true);
    };

    const handleBlur = () => {
      setIsWindowFocused(false);
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', handleFocus);
    window.addEventListener('blur', handleBlur);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', handleFocus);
      window.removeEventListener('blur', handleBlur);
    };
  }, []);

  const requestNotificationPermission = useCallback(async () => {
    if (!("Notification" in window)) {
      console.log("This browser does not support notifications");
      return false;
    }

    if (Notification.permission === "default") {
      try {
        const permission = await Notification.requestPermission();
        console.log("Notification permission:", permission);
        return permission === "granted";
      } catch (error) {
        console.error("Error requesting notification permission:", error);
        return false;
      }
    }

    return Notification.permission === "granted";
  }, []);

// Somewhere suitable (e.g., App guard, root layout)
const ONE_HOUR = 60 * 60 * 1000;

// Expired or corrupt session data: clear all browser storage and go to login.
const cleanupAndRedirect = endSession;

const boot = () => {
  const raw = secureGet(localStorage, "wrapperData");

  if (!raw) {
    // cleanupAndRedirect();
    return;
  }

  try {
    const data = JSON.parse(raw);

    // Use existing loginTimestamp (must be epoch ms)
    const ts = typeof data?.loginTimestamp === "number" ? data.loginTimestamp : NaN;
    console.log("Login timestamp:", ts);
    // If missing/invalid or older than 1 hour -> expire
    if (!Number.isFinite(ts) || Date.now() - ts > ONE_HOUR) {
      console.log("Session expired based on timestamp");
      cleanupAndRedirect();
      return;
    }

    // Still valid -> do nothing
  } catch {
    // Corrupted JSON -> cleanup
    cleanupAndRedirect();
  }
};

useEffect(() => {
  boot();
}, []);

  const handleAddParticipant = (roomID: string, participant: string) => {
    const room = controller.chatRooms.find((r) => r.chatRoomId === roomID);
    if (!room) {
      console.error(`Room with ID ${roomID} not found.`);
      return false;
    }

    try {
      controller.addParticipant(room.chatRoomId, participant);
      if (currentRoom && currentRoom.chatRoomId === roomID) {
        setCurrentRoom(room);
        saveCurrentRoomToStorage(room);
      }
      setRooms([...controller.chatRooms]);
      localStorage.setItem("chatRooms", JSON.stringify(controller.chatRooms.map((r) => r.toMap())));
      return true;
    } catch (error) {
      console.error(`Failed to add participant ${participant} to room ${roomID}:`, error);
      return false;
    }
  };


  const handleRemoveParticipant = (roomID: string, participant: string) => {
    const room = controller.chatRooms.find((r) => r.chatRoomId === roomID);
    if (!room) {
      console.error(`Room with ID ${roomID} not found.`);
      return false;
    }

    try {
      controller.removeParticipant(room.chatRoomId, participant);
      if (currentRoom && currentRoom.chatRoomId === roomID) {
        setCurrentRoom(room);
        saveCurrentRoomToStorage(room);
      }
      setRooms([...controller.chatRooms]);
      localStorage.setItem("chatRooms", JSON.stringify(controller.chatRooms.map((r) => r.toMap())));
      return true;
    } catch (error) {
      console.error(`Failed to remove participant ${participant} to room ${roomID}:`, error);
      return false;
    }
  };




  const saveCurrentRoomToStorage = useCallback((room: ChatRoom | null) => {
    if (room) {
      const roomToSave = {
        chatRoomId: room.chatRoomId,
        username: room.username,
        Messages: room.messages.map(msg => {
          if (msg instanceof Message) {
            return {
              ...msg,
              sentTime: msg.sentTime,
              deliveredTime: msg.deliveredTime,
              seenTimes: msg.seenTimes,
              editedTime: msg.editedTime,
              deletedTime: msg.deletedTime
            };
          } else if (msg instanceof FileMessage) {
            return {
              ...msg,
              sentTime: msg.sentTime,
              deliveredTime: msg.deliveredTime,
              seenTimes: msg.seenTimes,
              editedTime: msg.editedTime,
              deletedTime: msg.deletedTime
            };
          }
          return msg;
        }),
        isSessionActive: room.isSessionActive,
        unreadMessageCount: room.unreadMessageCount,
        isConference: room.isConference,
        isGroup: room.isGroup,
        isAgent: room.isAgent,
        type: room.type,
        isCreator: room.isCreator,
        participants: room.participants,
        admin: room.admin,
      };
      localStorage.setItem("currentRoom", JSON.stringify(roomToSave));
      console.log("Saved current room to storage with updated message statuses");
    } else {
      localStorage.removeItem("currentRoom");
    }
  }, []);

  const restoreCurrentRoomFromStorage = useCallback(() => {
    const storedCurrentRoom = localStorage.getItem("currentRoom");
    if (storedCurrentRoom && rooms.length > 0) {
      try {
        const roomData = JSON.parse(storedCurrentRoom);
        const foundRoom = rooms.find(room =>
          room.chatRoomId === roomData.chatRoomId &&
          (room.username === roomData.username &&
            room.isAgent === roomData.isAgent &&
            room.isConference === roomData.isConference &&
            room.isGroup === roomData.isGroup)
        );

        if (foundRoom) {
          foundRoom.participants = roomData.participants || foundRoom.participants;
          foundRoom.isSessionActive = roomData.isSessionActive ?? foundRoom.isSessionActive;
          foundRoom.unreadMessageCount = roomData.unreadMessageCount ?? foundRoom.unreadMessageCount;
          foundRoom.admin = roomData.admin ?? foundRoom.admin;

          console.log("Restoring current room from localStorage:", foundRoom.username);
          console.log("Participants count:", foundRoom.participants?.length);
          setCurrentRoom(foundRoom);
          return foundRoom;
        } else {
          localStorage.removeItem("currentRoom");
        }
      } catch (error) {
        console.error("Error parsing stored current room:", error);
        localStorage.removeItem("currentRoom");
      }
    }
    return null;
  }, [rooms]);

  const handleDeleteChatRoom = (roomId: string) => {
    if (currentRoom && currentRoom.chatRoomId === roomId) {
      saveCurrentRoomToStorage(null);
    }

    controller.deleteChatRoom(roomId);
    setRooms([...controller.chatRooms]);
    handleSelectRoom(null);
  }

  console.log("context loading", loading);





  const handleaddRequest = (newRequest: MyRequest) => {
    requestController.addRequest(newRequest);
    setreqCount((prevCount) => prevCount + 1);
  }
  const handleremoveRequest = (reqId: string) => {
    requestController.removeRequestById(reqId);
    setreqCount((prevCount) => prevCount - 1);
  }

  const handleaddServerRequest = (newRequest: MyRequest) => {
    requestController.addServerRequest(newRequest);
  }
  const handleremoveServerRequest = (reqId: string) => {
    requestController.removeServerRequestById(reqId);
  }
  const handlefindServerRequest = (reqId: string): MyRequest | null => {
    return requestController.findServerRequestById(reqId);
  }
  const handlefindRequest = (reqId: string): MyRequest | null => {
    return requestController.findRequestById(reqId);
  }
  const handleupdateReqStatusById = (reqId: string, status: string) => {
    requestController.updateRequestStatusById(reqId, status);
  }

  const addNotification = (notification: MyNotifications) => {
    notificationController.addNotification(notification);
    setnotifCount((prevCount) => prevCount + 1);
  };

  const handleSelectRoom = useCallback(
    (room?: ChatRoom | null) => {
      if (!room) {
        setCurrentRoom(null); // Clear the current room
        saveCurrentRoomToStorage(null); // Clear from localStorage
        setRooms([...controller.chatRooms]); // Update the state
        return;
      }

      if (room.unreadMessageCount > 0) {
        room.unreadMessageCount = 0;
        localStorage.setItem("chatRooms", JSON.stringify(controller.chatRooms.map((r) => r.toMap())));
      }

      // Handle case when a room is selected
      setCurrentRoom(room);
      saveCurrentRoomToStorage(room); // Save to localStorage
      setRooms([...controller.chatRooms]);
      console.log("current room: " + room.username);
    },
    [controller, saveCurrentRoomToStorage]
  );

  const initializeChatRooms = () => {
    const storedChatRooms = localStorage.getItem("chatRooms");
    console.log("in initialize", storedChatRooms);

    if (storedChatRooms) {
      try {
        const parsedRooms = JSON.parse(storedChatRooms);
        return parsedRooms.map((roomData: any) => {
          const restoredMessages = (roomData.messages || []).map((msgData: any) => {
            let seenTimes: SeenEntry[] = [];
            if (msgData.seenTimes !== undefined && msgData.seenTimes !== null) {
              if (typeof msgData.seenTimes === 'string') {
                try {
                  if (msgData.seenTimes === '' || msgData.seenTimes === '[]') {
                    seenTimes = [];
                  } else {
                    const parsedSeenTimes = JSON.parse(msgData.seenTimes);
                    seenTimes = Array.isArray(parsedSeenTimes) ? parsedSeenTimes.map((entry: any) => ({
                      name: entry.name,
                      time: new Date(entry.time)
                    })) : [];
                  }
                } catch (error) {
                  console.warn("Failed to parse seenTimes string:", msgData.seenTimes, error);
                  seenTimes = [];
                }
              } else if (Array.isArray(msgData.seenTimes)) {
                seenTimes = msgData.seenTimes.map((entry: any) => ({
                  name: entry.name,
                  time: new Date(entry.time)
                }));
              }
            }
            const isOwner = msgData.isOwner === 1 || msgData.isOwner === true;

            if (msgData.fileUrl || msgData.fileName) {
              return new FileMessage(
                msgData.text,
                msgData.fileName,
                msgData.filePath,
                msgData.fileType,
                msgData.messageId,
                isOwner,
                msgData.chatRoomId,
                msgData.senderName,
                msgData.repliedMessage ? new Message(
                  msgData.repliedMessage.text,
                  msgData.repliedMessage.messageId,
                  msgData.repliedMessage.isOwner,
                  msgData.repliedMessage.chatRoomId,
                  msgData.repliedMessage.senderName,
                  null,
                  msgData.repliedMessage.sentTime ?   msgData.repliedMessage.sentTime : null,
                  msgData.repliedMessage.deliveredTime ? msgData.repliedMessage.deliveredTime : null,
                  msgData.repliedMessage.seenTimes || [],
                  msgData.repliedMessage.editedTime ? msgData.repliedMessage.editedTime : null,
                  msgData.repliedMessage.deletedTime ? msgData.repliedMessage.deletedTime : null,
                  msgData.repliedMessage.arrivalTime ? msgData.repliedMessage.arrivalTime : null,

                ) : null,
                msgData.sentTime ? new Date(msgData.sentTime) : null,
                msgData.deliveredTime ? new Date(msgData.deliveredTime) : null,
                                                msgData.arrivalTime ? new Date(msgData.arrivalTime) : null,

                seenTimes,
                msgData.editedTime ? new Date(msgData.editedTime) : null,
                msgData.deletedTime ? new Date(msgData.deletedTime) : null,

              );
            } else {
              let repliedMessage = null;
              if (msgData.repliedMessage) {
                let repliedSeenTimes: SeenEntry[] = [];
                if (msgData.repliedMessage.seenTimes) {
                  repliedSeenTimes = Array.isArray(msgData.repliedMessage.seenTimes)
                    ? msgData.repliedMessage.seenTimes
                    : [];
                }

                repliedMessage = new Message(
                  msgData.repliedMessage.text,
                  msgData.repliedMessage.messageId,
                  msgData.repliedMessage.isOwner,
                  msgData.repliedMessage.chatRoomId,
                  msgData.repliedMessage.senderName,
                  null,
                  msgData.repliedMessage.sentTime ? msgData.repliedMessage.sentTime : null,
                  msgData.repliedMessage.deliveredTime ? msgData.repliedMessage.deliveredTime : null,
                  repliedSeenTimes,
                  msgData.repliedMessage.editedTime ? msgData.repliedMessage.editedTime : null,
                  msgData.repliedMessage.deletedTime ? msgData.repliedMessage.deletedTime : null,
                  msgData.repliedMessage.arrivalTime ? msgData.repliedMessage.arrivalTime : null

                );
              }

              return new Message(
                msgData.text,
                msgData.messageId,
                isOwner,
                msgData.chatRoomId,
                msgData.senderName,
                repliedMessage,
                msgData.sentTime ? msgData.sentTime : null,
                msgData.deliveredTime ? msgData.deliveredTime : null,

                seenTimes,
                msgData.editedTime ? msgData.editedTime : null,
                msgData.deletedTime ? msgData.deletedTime : null,
                msgData.arrivalTime ? msgData.arrivalTime : null,

              );
            }
          });

          return new ChatRoom(
            roomData.chatRoomId,
            roomData.username,
            restoredMessages,
            roomData.type,
            roomData.isSessionActive,
            roomData.unreadMessageCount,
            roomData.isConference,
            roomData.isGroup,
            roomData.isAgent,
            roomData.isCreator,
            roomData.participants || [],
            roomData.admin
          );
        });
      } catch (error) {
        console.error("Error parsing stored chat rooms:", error);
      }
    }
    return [];
  };
  const restoreRoomFromUrl = useCallback((roomId: string) => {
    console.log("Attempting to restore room from URL:", roomId);

    if (!roomId || rooms.length === 0) return null;

    const decodedRoomId = decodeURIComponent(roomId);
    console.log("Decoded room ID:", decodedRoomId);

    const foundRoom = rooms.find(room =>
      room.chatRoomId === roomId ||
      room.username === roomId ||
      room.chatRoomId === decodedRoomId ||
      room.username === decodedRoomId ||
      room.chatRoomId.includes(roomId) ||
      room.username.includes(roomId) ||
      room.chatRoomId.includes(decodedRoomId) ||
      room.username.includes(decodedRoomId)
    );

    if (foundRoom) {
      console.log("Found room from URL:", foundRoom.username);
      setCurrentRoom(foundRoom);
      saveCurrentRoomToStorage(foundRoom);
      return foundRoom;
    }

    console.log("No room found for URL roomId:", roomId, "or decoded:", decodedRoomId);
    console.log("Available rooms:", rooms.map(r => ({ id: r.chatRoomId, username: r.username })));
    return null;
  }, [rooms, saveCurrentRoomToStorage]);

  useEffect(() => {
    const initialRooms = initializeChatRooms();
    console.log("Initialized rooms from storage, count:", initialRooms);
    // setRooms(initialRooms);
  }, []);

  useEffect(() => {
    if (rooms.length > 0 && !currentRoom) {
      console.log("Rooms loaded, attempting restoration. Rooms count:", rooms.length);

      const currentPath = window.location.pathname;
      if (currentPath.startsWith('/chat/')) {
        const roomIdFromUrl = currentPath.split('/chat/')[1];
        if (roomIdFromUrl) {
          const restoredFromUrl = restoreRoomFromUrl(roomIdFromUrl);
          if (restoredFromUrl) {
            console.log("Successfully restored room from URL");
            return;
          }
        }
      }

      const restoredFromStorage = restoreCurrentRoomFromStorage();
      if (restoredFromStorage) {
        console.log("Successfully restored room from localStorage");
      } else {
        console.log("No room could be restored");
      }
    }
  }, [rooms.length, currentRoom, restoreCurrentRoomFromStorage, restoreRoomFromUrl]);

  // Subscribe to wrapper connection state events
  useEffect(() => {
    if (!wrapperInstance) {
      setConnectionState('disconnected');
      return;
    }

    // Get initial connection state (if available)
    const initialState = (wrapperInstance as any).getConnectionState?.() || 'disconnected';
    setConnectionState(initialState);

    console.log("Subscribing to wrapper connection events");

    // Listen for connection state changes from the endpoint/connectionManager
    const handleConnectionStateChanged = (state: string) => {
      console.log("MSRContext received connection state change:", state);
      setConnectionState(state);
    };

    // Subscribe to connection state changes
    if ((wrapperInstance as any).endpoint) {
      (wrapperInstance as any).endpoint.on('connectionStateChanged', handleConnectionStateChanged);
    }

    const handleClientConnected = (data: any) => {
      console.log('MSRContext received ClientConnected event:', data);
      void playClientConnectedPing();
    };

    if ((wrapperInstance as any).endpoint) {
      (wrapperInstance as any).endpoint.on('ClientConnected', handleClientConnected);
    }

    return () => {
      console.log("Cleaning up wrapper connection event handlers");
      if ((wrapperInstance as any).endpoint) {
        (wrapperInstance as any).endpoint.off('connectionStateChanged', handleConnectionStateChanged);
        (wrapperInstance as any).endpoint.off('ClientConnected', handleClientConnected);
      }
    };
  }, [wrapperInstance, playClientConnectedPing]);

  const clearAllChatRooms = useCallback(() => {
    console.log("Clearing all chat rooms - removing all rooms and resetting state");
    controller.chatRooms = [];
    setRooms([]);
    setCurrentRoom(null);
    localStorage.removeItem("chatRooms");
    localStorage.removeItem("currentRoom");
    controller.saveChatRooms();
    console.log("All chat rooms cleared successfully");
  }, [controller]);


  const handleLeaveFromChat = (chatID: string) => {
    console.log("handleLeaveChat called with chatID:", chatID);
    const room = controller.chatRooms.find((room) => room.chatRoomId === chatID);
    if (room) {
      console.log("leaving chat from" + room.username);
      if (currentRoom && currentRoom.chatRoomId === chatID) {
        saveCurrentRoomToStorage(null);
        setCurrentRoom(null);
      }
      handleSessionActivation(room.username, false);
      const updatedRooms: ChatRoom[] = controller.chatRooms.map((r) => {
        if (r.username === room.username) {
          return {
            ...r,
            isSessionActive: false,
            toMap: r.toMap,
          };
        }
        return r;
      });
      setRooms(updatedRooms);
      localStorage.setItem("chatRooms", JSON.stringify(updatedRooms.map((r) => r.toMap())));
    }
  };



  const handlemarkAsRead = (chatID: string) => {
    controller.markMessagesAsRead(chatID);

    const targetRoom = controller.chatRooms.find(room => room.chatRoomId === chatID);

    if (targetRoom) {
      targetRoom.messages.forEach((message) => {
        if (!message.isOwner &&
          !message.seenTimes.some((seen: SeenEntry) => seen.name === Global.username + Global.companyDomain)) {
          message.seenTimes.push({
            name: Global.username + Global.companyDomain,
            time: new Date()
          });
        }
      });
      targetRoom.unreadMessageCount = 0;
    }

    setRooms([...controller.chatRooms]);
    controller.saveChatRooms();
    localStorage.setItem("chatRooms", JSON.stringify(controller.chatRooms.map((room) => room.toMap())));
  }

  const handlePublishEvent = (event: string) => {
    console.log(`published event: ${event} for agent ${Global.username + Global.companyDomain}`);
    const params = {
      id: generateRandomString(16),
      type: "publish",
      event: `agent-${event}`,
      publisher: Global.username + Global.companyDomain,
    };
    wrapperInstance?.sendMsg(JSON.stringify(params), "application/rechat.cntl+json");
    setCurrentMode(event);
  };

  const handleAgentListResponse = useCallback((names: string[], statuses: string[], types: number[] = []) => {
    console.log("agent list response has been called", names);
    console.log("statuses:", statuses);
    const fetchedAgents = names.map((name, index) => ({
      id: index + 1,
      name,
      status: statuses[index],
      type: types[index],
    }));

    console.log("fetchedAgents:", fetchedAgents);
    setAgents(fetchedAgents);
    console.log("setAgents called with", fetchedAgents.length, "agents");

    // Save ALL agents to globals (not just available ones)
    // This allows components to access all agents and filter/disable as needed
    setAvailableAgents(fetchedAgents);
    console.log("setAvailableAgents called");
  }, []);

  // Register the agent list handler globally so WebSocket responses work
  useEffect(() => {
    console.log("🔧 Registering handleAgentListResponse globally");
    setHandleAgentListResponse(handleAgentListResponse);
    return () => {
      console.log("🔧 Unregistering handleAgentListResponse");
    };
  }, [handleAgentListResponse]);

  const updateAgentList = (filter: string) => {
    console.log(" updateAgentList called with filter:", filter);
    console.log(" wrapperInstance:", wrapperInstance ? "exists" : "null");
    wrapperInstance?.sendMsg(
      createRequestControlMessage(
        generateRandomString(16),
        "agent-list",
        `from-name:${Global.username + Global.companyDomain}, filter:${filter},start-date:Mon 15 May 2006 +0300,end-date:Mon 15 May 2025 +0300`
      ),
      "application/rechat.cntl+json"
    );
    console.log("agent-list request sent");
  };
  const handleChatListResponse = (names: string[], types: string[], statuses: string[]) => {
    console.log("chat list response has been called");
    const fetchedChatRooms = names.map((name, index) => ({
      id: index + 1,
      name,
      type: types[index],
      status: statuses[index]
    }));
    setAvailableRooms([...fetchedChatRooms]);
    console.log("availableRoom in function", availableRooms);
  };

  const updateChatList = useCallback((type: string, personal: boolean, status: string) => {
    console.log("updateChatList called with type:", type, "and personal:", personal);
    const messageJson = {
      id: generateRandomString(16),
      type: "request",
      job: "chat-list",
      parameters: {
        "from-name": Global.username + Global.companyDomain,
        "chat-type": type,
        personal,
        "session-status": status,
      }
    };

    const messageJsonString = JSON.stringify(messageJson, null, 4);

    wrapperInstance?.sendMsg(
      messageJsonString,
      "application/rechat.cntl+json"
    );
  }, [wrapperInstance]);


  const messageHistoryReq = useCallback((toName: string, nextPage: number, limit: number) => {
    console.log("sending message history for:", toName, "and nextPage:", nextPage, "and limit:", limit);

    const messageJson = {
      id: generateRandomString(16),
      type: "request",
      job: "message-history",
      parameters: {
        "to-name": toName,
        "from-name": Global.username + Global.companyDomain,
        "page-number": nextPage,
        "limit": limit,
      }
    };

    const messageJsonString = JSON.stringify(messageJson, null, 4);

    wrapperInstance?.sendMsg(
      messageJsonString,
      "application/rechat.cntl+json"
    );
  }, [wrapperInstance]);

  const handleSessionActivation = useCallback(
    (chatroomName: string, status: boolean) => {
      const updatedRoom = controller.setChatroomSessionStatus(chatroomName, status);
      if (updatedRoom) {
        updatedRoom.isSessionActive = status;
      }

      setRooms([...controller.chatRooms]);
      localStorage.setItem("chatRooms", JSON.stringify(controller.chatRooms.map((room) => room.toMap()))); // Save to localStorage

      if (currentRoom && currentRoom.username === chatroomName && updatedRoom) {
        setCurrentRoom(updatedRoom);
        saveCurrentRoomToStorage(updatedRoom);
      }
    },
    [controller, currentRoom]
  );

  const addRoom = useCallback(
    (chatroomName: string, participants: string[], chatroomId: string, status: string, type: string) => {
      let isAgent = false;
      let isConference = false;
      let isGroup = false;
      let isCreator = false;
      let admin = participants.length > 0 ? participants[0] : "";
      let isactive = status === "active";

      if (admin === Global.username + Global.companyDomain) {
        isCreator = true;
      }

      if (type === "agent-to-agent") {
        let split1 = chatroomName.split(":");
        let chatnamesplit = split1[1].split("+");
        let chatname;
        if (chatnamesplit[0] === Global.username + Global.companyDomain) {
          chatname = chatnamesplit[1];
        } else {
          chatname = chatnamesplit[0];
        }
        console.log("chatname", chatname);
        chatroomName = chatname;
      } else if (type === "c2a") {
        let chatnamesplit = chatroomName.split("+");
        let chatname;
        if (chatnamesplit[0] === Global.username + Global.companyDomain) {
          chatname = chatnamesplit[1];
        } else {
          chatname = chatnamesplit[0];
        }
        console.log("chatname", chatname);
        chatroomName = chatname;
      }


      if (type === "conference") {
        isConference = true;
      } else if (type === "group-chat") {
        isGroup = true;
      } else if (type === "agent-to-agent") {
        isAgent = true;
      }

      const existingRoom = controller.chatRooms.find((room) => room.username === chatroomName && room.chatRoomId === chatroomId);


      if (existingRoom) {
        handleSessionActivation(existingRoom.username, isactive);
        existingRoom.participants = participants;
        existingRoom.isSessionActive = isactive;
        existingRoom.admin = admin;
        console.log(`Room "${chatroomName}" already exists.`);
        setRooms([...controller.chatRooms]);
        localStorage.setItem("chatRooms", JSON.stringify(controller.chatRooms.map((room) => room.toMap())));
        return;
      } else {
        let newChatRoom;
        if (type === "group-chat") {
          newChatRoom = controller.createMultiUserRoom(chatroomId, chatroomName, [], status, participants, "group-chat", isCreator, admin);
        } else if (type === "conference") {
          newChatRoom = controller.createMultiUserRoom(chatroomId, chatroomName, [], status, participants, "conference", isCreator, admin);
        } else {
          newChatRoom = controller.createChatRoom(chatroomId, chatroomName, isAgent, status);
        }
        if (newChatRoom) {
          handleSessionActivation(newChatRoom.username, isactive);
          setRooms([...controller.chatRooms]);

          localStorage.setItem(
            "chatRooms",
            JSON.stringify(controller.chatRooms.map(room => room.toMap()))
          );
        }
      }
    },
    [controller, handleSessionActivation]
  );




  const setAdmin = useCallback((chatroomId: string, admin: string) => {
    const room = controller.chatRooms.find((room) => room.username === chatroomId);
    if (room) {
      room.admin = admin;
      if (currentRoom && currentRoom.username === chatroomId) {
        saveCurrentRoomToStorage(room);
      }
    }
    setRooms([...controller.chatRooms]);
    localStorage.setItem("chatRooms", JSON.stringify(controller.chatRooms.map((room) => room.toMap())));
  }, [controller, currentRoom, saveCurrentRoomToStorage]);


  const setIsCreator = useCallback((chatroomId: string, iscreator: boolean) => {
    const room = controller.chatRooms.find((room) => room.username === chatroomId);
    if (room) {
      room.isCreator = iscreator;

      // Update current room in localStorage if it's the same room
      if (currentRoom && currentRoom.username === chatroomId) {
        saveCurrentRoomToStorage(room);
      }
    }
    setRooms([...controller.chatRooms]);
    localStorage.setItem("chatRooms", JSON.stringify(controller.chatRooms.map((room) => room.toMap())));
  }, [controller, currentRoom, saveCurrentRoomToStorage]);

  const handleReceiveFileMessage = useCallback(
    (filemessage: FileMessage) => {
      let existingChatRoom;

      if (filemessage.chatRoomId.includes("grpcht:") || filemessage.chatRoomId.includes("conf:")) {
        existingChatRoom = controller.chatRooms.find((room) => room.chatRoomId === filemessage.chatRoomId);
      } else {
        existingChatRoom = controller.chatRooms.find((room) => room.username.includes(filemessage.senderName));
      }

      if (existingChatRoom) {
        const isCurrentlyViewingRoom = currentRoom?.chatRoomId === existingChatRoom.chatRoomId;

        // Notify unread divider context about new file message
        unreadDividerContext.handleNewMessage(
          existingChatRoom.chatRoomId,
          filemessage.messageId,
          filemessage.isOwner,
          isCurrentlyViewingRoom,
          false, // isUserAtBottom - safe default
          isWindowFocused
        );

        const updatedRoom = controller.addMessage(filemessage, existingChatRoom.chatRoomId);
        if (!filemessage.isOwner &&
          filemessage.seenTimes.length === 0 &&
          !isCurrentlyViewingRoom) {
          existingChatRoom.unreadMessageCount++;
        }

        if (updatedRoom) {
          setRooms([...controller.chatRooms]);
          controller.saveChatRooms();
          if (currentRoom && currentRoom.chatRoomId === updatedRoom.chatRoomId) {
            saveCurrentRoomToStorage(updatedRoom);
          }
        }
      }
    },
    [controller, currentRoom, saveCurrentRoomToStorage, setRooms, unreadDividerContext, isWindowFocused]
  );

  const handleSendFileMessage = useCallback(
    (filemessage: FileMessage) => {
      if (currentRoom) {
        const updatedRoom = controller.addMessage(
          filemessage,
          currentRoom.chatRoomId
        );

        if (updatedRoom) {
          setRooms([...controller.chatRooms]);
          controller.saveChatRooms();
          saveCurrentRoomToStorage(updatedRoom);
        }
      }
      setRepliedMessage(null);
    },
    [currentRoom, controller, saveCurrentRoomToStorage]
  );

  const handleReceiveRepliedMessage = useCallback(
    (
      repliedMessageId: string
    ): { repliedMessage: Message | FileMessage | null; chatRoom: any; roomType: string | null } => {
      console.log("handleReceiveRepliedMessage called with id:", repliedMessageId);
      for (const room of controller.chatRooms) {
        const foundMsg = room.messages.find((msg) => msg.messageId === repliedMessageId);
        console.log("room.messages", room.messages)
        if (foundMsg instanceof Message || FileMessage) {
          console.log("found message", foundMsg, "room:", ChatRoom, "roomtype:", room.type);

          console.log("FOUND REPLIED MESSAGE:", {       repliedMessage: foundMsg,
            chatRoom: room,
            roomType: room.type || null,});
          return {
            repliedMessage: foundMsg,
            chatRoom: room,
            roomType: room.type || null,
          };
        }
      }

      return { repliedMessage: null, chatRoom: null, roomType: null };
    },
    [controller]
  );

  const handleReceiveMessage = useCallback(
    (
      text: string,
      messageId: string,
      sender: string,
      receiver: string,
      isOwner: boolean,
      roomType: string,
      repliedMessageId?: string
    ) => {
      let existingChatRoom = null;
      let repliedMessage: Message | null = null;
      console.log("handleReceiveMessage called with messageId:", messageId, "from:", sender, "to:", receiver, "roomType:", roomType);
      const hasBrowserFocus = typeof document !== "undefined" ? document.hasFocus() : true;
      const isBrowserVisible = typeof document !== "undefined" ? !document.hidden : true;
      const shouldPlayIncomingSound = !isOwner && (!isWindowFocused || !hasBrowserFocus || !isBrowserVisible);

      if (shouldPlayIncomingSound) {
        void playIncomingMessageSound();
      }
      const normalizeRoomKey = (value?: string) =>
        value
          ? value.replace(/^grpcht:/, "").replace(/^conf:/, "").replace(/@.*$/, "")
          : value;
      const normalizedReceiver = normalizeRoomKey(receiver);
      if (roomType == "c2a") {
        existingChatRoom = controller.chatRooms.find((room) => room.username === sender);
      } else if (roomType == "agent-to-agent" || roomType == "a2a" || roomType == "urgent:a2a") {
        existingChatRoom = controller.chatRooms.find((room) => room.username === sender);
      } else if (roomType == "conference") {
        // Normalize both sides: rooms may be stored as "conf:name" while receiver
        // arrives as "conf:name@domain" or "conf:name" — strip prefix + domain on both.
        existingChatRoom = controller.chatRooms.find(
          (room) => normalizeRoomKey(room.chatRoomId) === normalizedReceiver
        );
      } else if (roomType == "group-chat") {
        existingChatRoom = controller.chatRooms.find(
          (room) => normalizeRoomKey(room.chatRoomId) === normalizedReceiver
        );
      }
      console.log("reeeepplied message id", repliedMessageId)
      if (repliedMessageId) {
        const result = handleReceiveRepliedMessage(repliedMessageId);
        console.log("resssult", result)
        repliedMessage = result.repliedMessage;
        existingChatRoom = result.chatRoom;
        if (result.roomType) {
          roomType = result.roomType;
        }
      }

      if (!existingChatRoom) {
        if (roomType === "agent-to-agent" || roomType == "a2a" || roomType == "urgent:a2a") {
          existingChatRoom = controller.chatRooms.find((room) => room.username === sender);
          if (!existingChatRoom) {
            let id = "a2a:" + obtainSessionKey(sender, receiver);
            addRoom(id, [], id, "active", "agent-to-agent");
            existingChatRoom = controller.chatRooms.find((room) => room.username === sender);
          }
        } else if (roomType === "conference") {
          existingChatRoom = controller.chatRooms.find(
            (room) => normalizeRoomKey(room.username) === normalizedReceiver
          );
          if (!existingChatRoom) {
            const confId = `conf:${normalizedReceiver}`;
            addRoom(confId, [], confId, "active", roomType);
            existingChatRoom = controller.chatRooms.find(
              (room) => normalizeRoomKey(room.chatRoomId) === normalizedReceiver
            );
          }
        } else if (roomType === "group-chat") {
          existingChatRoom = controller.chatRooms.find(
            (room) => normalizeRoomKey(room.username) === normalizedReceiver
          );
          if (!existingChatRoom) {
            const grpId = `grpcht:${normalizedReceiver}`;
            addRoom(grpId, [], grpId, "active", roomType);
            existingChatRoom = controller.chatRooms.find(
              (room) => normalizeRoomKey(room.chatRoomId) === normalizedReceiver
            );
          }
        } else if (roomType === "c2a") {
          existingChatRoom = controller.chatRooms.find((room) => room.username === sender);
          if (!existingChatRoom) {
            let id = obtainSessionKey(sender, receiver);
            addRoom(sender, [], id, "active", roomType);
            existingChatRoom = controller.chatRooms.find((room) => room.username === sender);
          }
        }
      }

      let sentTime = null;
      let deliveredTime = new Date();
      let seenTimes: SeenEntry[] = [];
      let editedTime = null;
      let deletedTime = null;
      let arrivalTime = null;

      if (existingChatRoom) {
        console.log("all parameters:", text, messageId, isOwner, existingChatRoom.chatRoomId, sender, repliedMessage, sentTime, deliveredTime, seenTimes, editedTime, deletedTime, arrivalTime);
        const newMessage = new Message(text, messageId, isOwner, existingChatRoom.chatRoomId, sender, repliedMessage, sentTime, deliveredTime, seenTimes, editedTime, deletedTime, arrivalTime);

        const isCurrentlyViewingRoom = currentRoom?.chatRoomId === existingChatRoom.chatRoomId;
        console.log("NEW MESSAGE:", newMessage);

        // Notify unread divider context about new message
        // This handles divider creation for ALL rooms (not just the selected one)
        // For the selected room, ChatAreaChild will also handle this with actual scroll position
        // isUserAtBottom is false here as a safe default (divider will be created if user is not in this room)
        unreadDividerContext.handleNewMessage(
          existingChatRoom.chatRoomId, // sessionKey
          messageId,
          isOwner,
          isCurrentlyViewingRoom, // isUserInThisRoom
          false, // isUserAtBottom - safe default, ChatAreaChild handles actual value for selected room
          isWindowFocused
        );
        const updatedRoom = controller.addMessage(newMessage
          ,
          existingChatRoom.chatRoomId
        );
        if (!newMessage.isOwner &&
          newMessage.seenTimes.length === 0 &&
          !isCurrentlyViewingRoom) {
          existingChatRoom.unreadMessageCount++;
        }
        console.log("existing room id:", existingChatRoom.chatRoomId);
        console.log("current room id:", currentRoom?.chatRoomId);

        if (updatedRoom) {
          setRooms([...controller.chatRooms]);
          controller.saveChatRooms();
          if (currentRoom && currentRoom.chatRoomId === updatedRoom.chatRoomId) {
            saveCurrentRoomToStorage(updatedRoom);
          }
        }
      }
    },
    [controller, addRoom, handleReceiveRepliedMessage, currentRoom, saveCurrentRoomToStorage, unreadDividerContext, isWindowFocused, playIncomingMessageSound]
  );


  const handleRemoveMessage = useCallback(
    (messageId: string, chatRoomId: string) => {
      console.log("remove message with id:", messageId);
      let existingChatRoom = null;
      existingChatRoom = controller.chatRooms.find((room) => room.chatRoomId === chatRoomId);
      if (existingChatRoom) {
        const updatedRoom = controller.removeMessage(
          messageId,
          chatRoomId
        );
        if (updatedRoom) {
          setRooms([...controller.chatRooms]);
          controller.saveChatRooms();
        }
      }
    },
    [controller, handleSelectRoom]
  );

  const handleupdateMessage = useCallback(
    (msgId: string, newMessage: string) => {
      console.log("update message with id:", msgId);
      const chatRoomId = controller.findChatRoomIdByMessageId(msgId);
      console.log("message with id:" + msgId + " edited in chatroom with id:" + chatRoomId);
      if (!chatRoomId) return;

      const room = controller.chatRooms.find((room) => room.chatRoomId === chatRoomId);

      if (room) {
        const message = room.messages.find((msg) => msg.messageId === msgId);
        if (message && message instanceof Message) {
          message.text = newMessage;
          if (newMessage === "This message has been deleted") {
            message.deletedTime = new Date();
          } else {
            message.editedTime = new Date();
          }
          controller.saveChatRooms();

          // Update current room in localStorage if it's the same room
          if (currentRoom && currentRoom.chatRoomId === chatRoomId) {
            saveCurrentRoomToStorage(room);
          }
        }
      }

      setRooms([...controller.chatRooms]);
      localStorage.setItem("chatRooms", JSON.stringify(controller.chatRooms.map((room) => room.toMap())));
    },
    [controller, currentRoom, saveCurrentRoomToStorage]
  );

  const handleClearChatRoomMessages = useCallback(
    (chatRoomId: string) => {
      console.log(`Clearing all messages for chat room: ${chatRoomId}`);
      const room = controller.chatRooms.find((room) => room.chatRoomId === chatRoomId);

      if (!room) {
        console.error(`Chat room with ID ${chatRoomId} not found`);
        return false;
      }
      room.messages = [];
      room.unreadMessageCount = 0;
      setRooms([...controller.chatRooms]);
      controller.saveChatRooms();
      localStorage.setItem("chatRooms", JSON.stringify(controller.chatRooms.map((room) => room.toMap())));
      if (currentRoom && currentRoom.chatRoomId === chatRoomId) {
        setCurrentRoom(room);
        saveCurrentRoomToStorage(room);
      }
      console.log(`Successfully cleared ${room.messages.length} messages from room: ${room.username}`);
      return true;
    },
    [controller, currentRoom, saveCurrentRoomToStorage, setRooms]
  );

  const handleClearChatRoomMessagesByName = useCallback(
    (username: string) => {
      console.log(`Clearing all messages for chat room: ${username}`);
      const room = controller.chatRooms.find((room) => room.username === username);
      if (!room) {
        console.error(`Chat room with username ${username} not found`);
        return false;
      }

      return handleClearChatRoomMessages(room.chatRoomId);
    },
    [handleClearChatRoomMessages, controller]
  );


  const updateMessageStatus = useCallback((messageId: string, status: string, dateValue: Date, name: string) => {
    console.log(`Updating message ${messageId} with status ${status} to:`, dateValue, "by", name);

    const chatRoomId = controller.findChatRoomIdByMessageId(messageId);
    if (!chatRoomId) {
      console.warn(`Could not find chatRoomId for messageId: ${messageId}`);
      return;
    }

    const room = controller.chatRooms.find((room) => room.chatRoomId === chatRoomId);
    if (!room) {
      console.warn(`Could not find room with chatRoomId: ${chatRoomId}`);
      return;
    }

    const message = room.messages.find((msg) => msg.messageId === messageId);
    if (!message || !(message instanceof Message || message instanceof FileMessage)) {
      console.warn(`Could not find message with messageId: ${messageId}`);
      return;
    }

    switch (status) {
      case "sentTime":
        message.sentTime = dateValue;
        break;
      case "deliveredTime":
        message.deliveredTime = dateValue;
        break;
      case "seenTimes":
        message.seenTimes.push({ name: name, time: dateValue });
        console.log(`Set seenTime for message ${messageId} to:`, dateValue);
        break;
      case "editedTime":
        message.editedTime = dateValue;
        break;
      case "deletedTime":
        message.deletedTime = dateValue;
        break;
      default:
        console.warn(`Unknown status: ${status}`);
        return;
    }

    const updatedRooms = [...controller.chatRooms];
    setRooms(updatedRooms);

    controller.saveChatRooms();

    localStorage.setItem("chatRooms", JSON.stringify(updatedRooms.map((room) => room.toMap())));

    if (currentRoom && currentRoom.chatRoomId === room.chatRoomId) {
      setCurrentRoom(room);
      saveCurrentRoomToStorage(room);
    }

    console.log(`Successfully updated message ${messageId} status ${status}`);
  }, [controller, setRooms, currentRoom, saveCurrentRoomToStorage]);

  const handleAddMessageHistory = useCallback(
    (incoming: any[], _pageNumber?: number, _totalPageNumber?: number) => {
      if (!incoming || incoming.length === 0) return;
      console.log("incoming message history array:", incoming);

      console.log("pageNumber and totalPageNumber is", _pageNumber, _totalPageNumber);

      const isNextPage = !!_pageNumber && _pageNumber > 1;
      const currentUserFullName = Global.username + Global.companyDomain;

      // ---- 1) Target room (same heuristic you used) ----
      const sample = incoming[0];
      const { isOwner, sender, receiver, role } = sample;

      let room: ChatRoom | undefined;
      if (!isOwner && receiver !== currentUserFullName && !receiver?.startsWith("grpcht:") && !receiver?.startsWith("conf:")) {
        room = (role === "client")
          ? controller.chatRooms.find((r) => r.username === sender)
          : controller.chatRooms.find((r) => r.username === receiver);
      } else {
        if (!isOwner && (receiver?.startsWith("grpcht:") || receiver?.startsWith("conf:"))) {
          room = controller.chatRooms.find((r) => r.username === receiver);
        } else if (!isOwner) {
          room = controller.chatRooms.find((r) => r.username === sender);
        } else {
          room = controller.chatRooms.find((r) => r.username === receiver);
        }
      }

      if (!room) {
        console.warn("handleAddMessageHistory: target room not found.");
        return;
      }

      // ---- Helpers ----
const toDate = (v: any): Date | null => {
  if (v === null || v === undefined) return null;
  if (v instanceof Date) return v;

  try {
    if (typeof v === "number") {
      // If it's in seconds (10-digit), convert to ms
      if (v < 1e12) {
        return new Date(v * 1000);
      }
      // Already ms
      return new Date(v);
    }

    if (typeof v === "string") {
      const num = Number(v.trim());
      if (!Number.isNaN(num) && num > 0) {
        // String timestamp (seconds or ms)
        if (num < 1e12) {
          return new Date(num * 1000);
        }
        return new Date(num);
      }

      // Normal date string
      const d = new Date(v);
      return isNaN(d.getTime()) ? null : d;
    }

    // Farklı tipler için son çare
    const d = new Date(v);
    return isNaN(d.getTime()) ? null : d;
  } catch {
    return null;
  }
};

      const normSeen = (arr: any[]): SeenEntry[] =>
        Array.isArray(arr)
          ? arr.map((s: any) => ({ name: s?.name, time: toDate(s?.time) ?? new Date(0) }))
          : [];

      // ---- 2) Build existing map for reply linking to older messages already in room ----
      const existingMap = new Map<string, Message | FileMessage>(
        room.messages.map((m) => [m.messageId, m])
      );

      // ---- 3) Create instances for the whole batch (keep incoming order). For now repliedTo=null. ----
      // Support both:
      //  A) Message with messageType === 'file-transfer' + fileData
      //  B) Legacy FileMessage with fileName/filePath/fileType
      const created: Array<Message | FileMessage> = incoming.map((m) => {
        const seenTimes = normSeen(m.seenTimes);

        // Legacy FileMessage path (explicit fileName/filePath/fileType present)
        if (m.fileName && m.filePath && m.fileType) {
          return new FileMessage(
            m.text ?? m.message,
            m.fileName,
            m.filePath,
            m.fileType,
            m.messageId,
            !!m.isOwner,
            room!.chatRoomId,
            m.sender,
            null, // repliedTo will be wired later
            toDate(m.sentTime),
            toDate(m.deliveredTime),
            toDate(m.arrivalTime),
            seenTimes,
            toDate(m.editTime),
            toDate(m.deletedTime)
          );
        }

        // Default Message (text or file-transfer via messageType+fileData)
        return new Message(
          m.text,
          m.messageId,
          !!m.isOwner,
          room!.chatRoomId,
          m.sender,
          null, // repliedTo will be wired later
          toDate(m.sentTime),
          toDate(m.deliveredTime),
          seenTimes,
          toDate(m.editTime),
          toDate(m.deletedTime),
          toDate(m.arrivalTime),
          (m.messageType as "text" | "file-transfer") || "text",
          m.fileData || undefined,
          _pageNumber,
          _totalPageNumber
        );
      });

      // ---- 4) Map of created for in-batch reply linking ----
      const createdMap = new Map<string, Message | FileMessage>(created.map((m) => [m.messageId, m]));

      // ---- 5) Wire repliedTo: prefer existing (older) -> else created (same batch) ----
      for (const raw of incoming) {
        if (!raw.repliedMessageId) continue;

        const msg = createdMap.get(raw.messageId);
        if (!msg || !(msg instanceof Message)) continue;

        const replied =
          existingMap.get(raw.repliedMessageId) ||
          createdMap.get(raw.repliedMessageId) ||
          null;

        if (replied) {
          msg.repliedTo = replied as any;
        }
      }

      // ---- 6) Bulk add once (top for older pages, bottom for first page). No unread bumps for history. ----
      const position = isNextPage ? "top" : "bottom";
      const updated = controller.addMessages(created, room.chatRoomId, position);
      if (!updated) return;

      // ---- 7) Persist & UI ----
      setRooms([...controller.chatRooms]);
      controller.saveChatRooms();

      if (currentRoom && currentRoom.chatRoomId === updated.chatRoomId) {
        saveCurrentRoomToStorage(updated);
      }
    },
    [controller, currentRoom, saveCurrentRoomToStorage, setRooms]
  );

  useEffect(() => {
    console.log("login set it");
  }, [socketInstance]);

  useEffect(() => {
    const checkPageReload = () => {
      if (sessionStorage.getItem("reloaded")) {
        // alert("Sayfa yeniden yüklendi");
        return true;
      } else {
        sessionStorage.setItem("reloaded", "true");
        return false;
      }
    };

    const authorizeWrapper = async (storedData: string) => {
      try {
        setLoading(true);
        const parsedData = JSON.parse(storedData);
        await requestNotificationPermission();
        // Recover job_roles from the cached userData (set on login) so the
        // re-auth path uses the same MSRP role mapping as the initial login.
        const msrpRole = mapJobRoleToMsrpRole();
        let msrpSubrole = "";
        try {
          const cachedUser = secureGet(localStorage, "userData");
          if (cachedUser) {
            msrpSubrole = mapJobRoleToMsrpSubrole(JSON.parse(cachedUser)?.job_roles);
          }
        } catch {
          // fall through with no subrole
        }
        const wrp = createSocketInstance(parsedData.username, parsedData.password, parsedData.companyDomain, msrpRole, msrpSubrole, addRoom, handleReceiveFileMessage, handleReceiveMessage,
          requestController, notificationController, controller, handleSessionActivation, handleChatListResponse, setIsCreator, setAvailableRooms, addNotification, handleRemoveMessage,
          handleupdateMessage, handleaddRequest, handleremoveRequest, handleaddServerRequest, handleremoveServerRequest, handlefindServerRequest, handlefindRequest,
          handleupdateReqStatusById, handleAddMessageHistory, clearAllChatRooms,
          handleLeaveFromChat, handleAddParticipant, handleRemoveParticipant, updateMessageStatus);
        setWrapperInstance(wrp);

        let socketStatus = false;

        try {
          socketStatus = isSocketOpen || (await wrp.openSocket());
        } catch (socketError) {
          console.log("will set loading false");
          setLoading(false);
          setIsAuthenticated(false);
          setWrapperInstance(null);
          console.error("Socket open error:", socketError);
          console.log("will return now");
          return;
        }

        setIsSocketOpen(socketStatus);
        console.log("Socket Status:", socketStatus);
        console.log("typeee", typeof socketStatus);

        if (!socketStatus || typeof socketStatus === "object") {
          setLoading(false);
          setIsAuthenticated(false);
          setWrapperInstance(null);
          console.log("will return now", loading, isAuthenticated, wrapperInstance);
          return;
        }
        if (isSocketOpen || socketStatus) {
          console.log("in is socket open", isSocketOpen || socketStatus);
          const auth = await wrp.authorize();
          console.log("is wrapper auth", auth);
          if (auth === 1) {
            console.log("User authorized successfully", auth);
            setIsAuthenticated(true);
            setLoading(false);

            Global.username = parsedData.username;
            Global.displayname = parsedData.displayname || parsedData.username;
            Global.companyDomain = "@" + parsedData.companyDomain;

            //navigate("/") to dashboard
            return;
          } else {
            console.log("will set loading false");

            setLoading(false);
            setIsAuthenticated(false);
            setWrapperInstance(null);
          }
        }
      } catch (error) {
        console.error("Error during authorization:", error);
      }
    };

    const initialize = async () => {
      // if (!checkPageReload()) return;
      console.log("in initialize function");
      const storedWrapperData = secureGet(localStorage, "wrapperData");
      if (storedWrapperData) {
        await authorizeWrapper(storedWrapperData);
      } else {
        setLoading(false);
        setIsAuthenticated(false);
        setWrapperInstance(null);
      }
    };

    initialize();
  }, [requestNotificationPermission]);

  const requestController = new RequestController(wrapperInstance!, addRoom, handleAddParticipant, toast);



  return (
    <ChatContext.Provider
      value={{
        rooms,
        setRooms,
        currentRoom,
        isAuthenticated,
        setIsAuthenticated,
        loading,
        handleAgentListResponse,
        updateAgentList,
        updateChatList,
        handleChatListResponse,
        addRoom,
        handleSelectRoom,
        handleReceiveFileMessage,
        handleSendFileMessage,
        handleReceiveMessage,
        handleSessionActivation,
        requestController,
        notificationController,
        controller,
        wrapper: wrapperInstance,
        setWrapper: setWrapperInstance,
        agents,
        availableRooms,
        setIsCreator,
        setAvailableRooms,
        currentMode,
        setCurrentMode,
        currentLanguage,
        setcurrentLanguage,
        handlePublishEvent,
        addNotification,
        handleRemoveMessage,
        handleupdateMessage,
        notifCount,
        setnotifCount,
        reqCount,
        setreqCount,
        handleaddRequest,
        handleremoveRequest,
        handleaddServerRequest,
        handleremoveServerRequest,
        handlefindServerRequest,
        handlefindRequest,
        handleupdateReqStatusById,
        repliedMessage,
        setRepliedMessage,
        handleAddMessageHistory,
        // handleAddMessageHistoryArray,
        handleDeleteChatRoom,
        saveCurrentRoomToStorage,
        handlemarkAsRead,
        messageHistoryReq,
        clearAllChatRooms,
        handleClearChatRoomMessagesByName,
        handleLeaveFromChat,
        setAdmin,
        handleAddParticipant,
        handleRemoveParticipant,
        updateMessageStatus,
        setCurrentRoom,
        restoreRoomFromUrl,
        requestNotificationPermission,

        // Connection state
        connectionState,
        isConnected,
        isReconnecting,
      }}
    >
      {children}
      {/*
        Defaults kept these on screen for five seconds, and react-toastify's
        container is a fixed 320px strip with no `pointer-events: none` (see
        index.css), so the top-right corner swallowed clicks the whole time —
        right where the page's action buttons sit. Short, dismissable, and
        capped so a burst of saves can't stack into a wall.
      */}
      <ToastContainer
        autoClose={2000}
        closeOnClick
        pauseOnFocusLoss={false}
        limit={3}
        newestOnTop
      />
    </ChatContext.Provider>
  );
}